import { Config } from '@mfec/types/tefComs';

// Possible "steps" in component
export enum DisplayMode {
  view = 'View',
  edit = 'Edit',
}

export const config : Config = {
  componentTagName: 'tef-coms4p',
  theme: {
    occl: {
      fonts: [
        {
          src: '/fonts/OnAir-Regular.woff2', family: 'On Air', weight: '400', style: 'normal', display: 'swap',
        },
        {
          src: '/fonts/OnAir-Bold.woff2', family: 'On Air', weight: '700', style: 'normal', display: 'swap',
        },
      ],
      resources: [
        { path: '/v3/components/theme/bundle.css' },
        { path: '/v3/components/icon/bundle.js' },
        { path: '/v3/components/modal/bundle.js' },
        { path: '/v3/library/vendors.js' },
      ],
    },
    tefOne: {
      // https://one.o9.de/main/nettokom/variables.css
      // |----theme-base-url------------|---config---------------
      resources: [
        { path: '/variables.css' },
        { path: '/components.css' },
        { path: '../bundle.js' },
      ],
    },
  },
};
